export default __webpack_public_path__ + "static/media/HIW3.b4ffdf11.svg";